// All the types in this file are tied to the PI Backend and were copied from client-core 12/21/2023
// The CoreAPI endpoint serializes SMAC enums as ints where-as the data sync serializes the SMAC enums as strings
// We support both until we can guarantee the data sync is always used

export enum AccountClassificationType {
  UNKNOWN = 'Unknown',
  CLIENT = 'Client',
  SELLER = 'Seller',
  SELLER_GRANTED_TRIAL = 'SellerGrantedTrial',
  WORKSHOP = 'Workshop',
  DYNAMIC_DEMO = 'DynamicDemo',
  TEST = 'Test',
  LEGACY_DEMO_ACCOUNT = 'LegacyDemoAccount',
  LEGACY_BUSINESS_ACCOUNT = 'LegacyBusinessAccount',
}

export type ValueMetric = {
  name: string;
  limit: number;
  consumed: number;
  available: number;
  metadata: null;
  companyGuid: string;
  userGuid: string;
  product: number;
  operationSuccessful: boolean;
  operation: number;
};

export type ModuleAccessConfiguration = {
  name: ModuleName;
  accessLevel: ModuleAccessLevel | ModuleAccessLevelString;
  valueMetrics: Array<ValueMetric>;
  timeTrials: Array<TimeTrial>;
  moduleExperienceType: ModuleExperienceType | ModuleExperienceTypeString;
  moduleAccountType: ModuleAccountType | ModuleAccountTypeString;
};

/**
 * This type was crafted from the return payload of the SMAC. It does not
 * directly reflect client-core as of 12/21/2023 because client-core indicates
 * it is using an older version of this type.
 */
export type TimeTrial = {
  timeTrialId: string; // guid
  startDate: string; // DateTime
  endDate: string; // DateTime
  durationDays: number;
  isExpired: boolean;
  associatedValueMetricName: string;
  associatedUserId: string; // Guid
  companyId: string; // Guid
  apiCompanyId: string;
};

export enum ModuleName {
  Unknown = 'Unknown',
  Hire = 'Hire',
  Inspire = 'Inspire',
  Design = 'Design',
  Diagnose = 'Diagnose',
  HireHero = 'HireHero',
  Design2 = 'Design2',
  Diagnose2 = 'Diagnose2',
  Inspire2 = 'Inspire2',
  Perform = 'Perform',
}

export enum ModuleAccessLevelString {
  Unknown = 'Unknown',
  NoAccess = 'NoAccess',
  BasicAccess = 'BasicAccess',
  CommonAccess = 'CommonAccess',
}

export enum ModuleAccessLevel {
  Unknown = 0,
  NoAccess = 1,
  BasicAccess = 2,
  CommonAccess = 3,
}

export enum ModuleExperienceTypeString {
  Unknown = 'Unknown',
  Classic = 'Classic', // Standard UX Experience for Module,
  SelfServe = 'SelfServe', // SelfServe Specific Experience for Module
}

export enum ModuleExperienceType {
  Unknown = 0,
  Classic = 1, // Standard UX Experience for Module,
  SelfServe = 2, // SelfServe Specific Experience for Module
}

export enum ModuleAccountTypeString {
  Unknown = 'Unknown',
  Free = 'Free',
  Paid = 'Paid',
}

export enum ModuleAccountType {
  Unknown = 0,
  Free = 1,
  Paid = 2,
}

export type SoftwareModuleAccessConfig = ModuleAccessConfiguration[];
